















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class HomeCate extends Vue {
  get cate() {
    return this.$store.state.homeCate;
  }

  private toCate(id: string) {
    this.$router.push({ path: 'cate', query: { cid: id } });
  }
}
